import styled from 'styled-components';

const ContentSpacing = styled.div`
  margin: 2rem;
`;

export default ContentSpacing;
